export const PrevArrowBtn = ({ onClick }) => {
  return <span onClick={onClick} className="icofont-long-arrow-left"></span>;
};
